// extracted by mini-css-extract-plugin
export default {"root":"AppBootScreen_root__EcOxA","content":"AppBootScreen_content__wpvP4","logo":"AppBootScreen_logo__4EzbY","progress":"AppBootScreen_progress__PFxE5"};